<div class="banner wrapper">
    <div id="prod-title" class="prod-title">
        <div class="row">
            <div class="col-xs-12 center-xs">
                <h5
                    class="text-align-center pt-25"
                >
                    {{ t["label.gb.title.merlin.pcn"] }}
                </h5>
                <hr class="hrLogin" />
            </div>
        </div>
    </div>
</div>
<div class="wrapper" id="login-wrapper">
    <div class="loader">
        <mat-spinner
            color="primary"
            class="spinner"
            [diameter]="75"
        ></mat-spinner>
        <div style="position:relative; top: 0px; left: -65px;">
            {{ t["label.gb.loading"] }}
        </div>
    </div>
</div>
